<template>
  <ToastModal
    ref="modal"
    :title="$t('SignUp.Women.SizeChart.Title')"
    show-mobile-footer
    :width="814"
    modal-id="SizeChartModal"
  >
    <div class="pt-6">
      <p class="o-body mb-6" v-text="$t('SignUp.Women.SizeChart.Description')" />
      <SizeChartMenu :title="$t('SignUp.Women.SizeChart.SizeSystem')" :sizechart-zone="sizechartZone" :country="country" class="mb-6" @click="sizechartZone = $event.zone" />
      <template v-if="!isHipsterMode">
        <TopSizeChart class="mb-6" :title="$t('Sizechart.TopSizeChart.Title')" table-class="table-fixed" :sizechart-zone="sizechartZone" />
        <div class="mb-6 text-women-text">
          <p class="o-body mb-3" v-text="$t('Sizechart.General.CantPickASize')" />
          <NewButton icon-right="new-chevron-right" color="black" variant="outline" @click="onClick">
            {{ $t('Sizechart.General.CantPickASizeCTA') }}
          </NewButton>
        </div>
      </template>
      <div
        class="max-w-400"
        :class="{ 'mb-6': isHipsterMode }"
      >
        <HipsterSizeChart :title="$t('Sizechart.HipsterSizeChart.Title')" table-class="table-fixed" :sizechart-zone="sizechartZone" />
      </div>
      <template v-if="isHipsterMode">
        <TopSizeChart class="mb-6" :title="$t('Sizechart.TopSizeChart.Title')" table-class="table-fixed" :sizechart-zone="sizechartZone" />
        <div class="mb-6 text-women-text">
          <p class="o-body mb-3" v-text="$t('Sizechart.General.CantPickASize')" />
          <NewButton icon-right="new-chevron-right" color="black" variant="outline" @click="onClick">
            {{ $t('Sizechart.General.CantPickASizeCTA') }}
          </NewButton>
        </div>
      </template>
      <div class="mb-3 mt-6">
        <OImage v-bind="sizeImage" img-class="rounded mx-auto" />
      </div>
      <p class="text-center o-body" v-html="$t('Sizechart.HipsterSizeChart.SizesShowcase')" />
    </div>
    <template v-slot:footer>
      <ToastModalFooter class="w-full md:w-auto" variant="outline" color="black" @click="onModalClose" />
    </template>
  </ToastModal>
</template>

<script>
import ToastModal from '@/components/ToastModal'
import NewButton from '@/components/NewButton'
import OImage from '@/components/OImage'
import TopSizeChart from '@/components/Women/TopSizeChart'
import HipsterSizeChart from '@/components/Women/HipsterSizeChart'
import SizeChartMenu from '@/components/Women/SizeChartMenu'
import { SizechartZonesCountryMap } from '@/enums/sizechart'
import { CountryCodes } from '@/enums/general'
import ToastModalFooter from '@/components/ToastModal/ToastModalFooter'
import { getImagePaths } from '@/utils/general'
import { Orientations } from '@/enums/products'

export default {
  name: 'SizeChartModal',
  components: { ToastModal, TopSizeChart, HipsterSizeChart, SizeChartMenu, ToastModalFooter, NewButton, OImage },
  props: {
    country: {
      type: String,
      default: CountryCodes.netherlands
    }
  },
  data () {
    return {
      sizechartZone: SizechartZonesCountryMap[this.country],
      viewMode: Orientations.womenbralette
    }
  },
  computed: {
    sizeImage () {
      return getImagePaths({
        path: '/images/frontend/static/size-wear',
        s3: true
      })
    },
    isHipsterMode () {
      return this.viewMode === Orientations.womenhipster
    }
  },
  methods: {
    toggleActivation () {
      this.$refs.modal.toggleActivation()
    },
    toggleBralette () {
      this.viewMode = Orientations.womenbralette
      this.$refs.modal.toggleActivation()
    },
    toggleHipster () {
      this.viewMode = Orientations.womenhipster
      this.$refs.modal.toggleActivation()
    },
    onModalClose () {
      this.$refs.modal.onModalClose()
    },
    onClick () {
      this.onModalClose()

      this.$router.push(this.$i18n.localePath({ name: 'women-bra-size' }))
    }
  }
}
</script>

<style scoped lang="postcss">
@screen md {
  .max-w-400 {
    max-width: 40rem;
  }

  >>> .toast-modal-button {
    @apply pb-6;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
